import { useReducer } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import { ImageUploadContext } from './context';
import { defaultContext } from './defaultContext';
import { imageUploadReducer } from './reducer';

export const ImageUploadProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const [state, dispatch] = useReducer(imageUploadReducer, defaultContext);

	const value = {
		state,
		dispatch,
	};
	return <ImageUploadContext.Provider value={value}>{children}</ImageUploadContext.Provider>;
};
